import * as Sentry from '@sentry/browser';
import { convertAnyToError } from './errorReporting.shared';
export default (error, extra = {}) => {
    Sentry.withScope(scope => {
        // https://github.com/getsentry/sentry-javascript/issues/1607#issuecomment-425974249
        Object.keys(extra).forEach(key => {
            scope.setExtra(key, extra[key]);
        });
        Sentry.captureException(convertAnyToError(error));
    });
};
//# sourceMappingURL=errorReporting.browser.js.map